import { useState } from "react"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"
import { useFormSubmit } from "shared/lib/useFormSubmit"

import { useUpdateProject } from "entities/projects/api/useUpdateProject"
import { useProject } from "features/project-management/model/useProject"
import { ProjectFormData } from "features/project-management/types/ProjectFormData"
import { ProjectFormTabType } from "features/project-management/types/ProjectFormTabType"

import { EditProjectOverlayModel } from "../EditProjectOverlay"
import { EditProjectOverlayConnectorProps } from "../EditProjectOverlayConnector"

export function useEditProjectOverlayModel({
  payload: { projectID }
}: EditProjectOverlayConnectorProps): EditProjectOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const [activeTab, setActiveTab] = useState<ProjectFormTabType>(
    ProjectFormTabType.GENERAL
  )
  const model = useProject(
    { projectID },
    { includePrice: activeTab === ProjectFormTabType.PRICES }
  )
  const { updateProject } = useUpdateProject()

  const submitProject = useEvent((formData: ProjectFormData) => {
    model.clarificationRequest?.handlers.onSubmitContent?.(
      formData.clarificationRequest?.content
    )
    return updateProject(projectID, formData.project)
  })

  const { handleSubmit, isSubmitting } = useFormSubmit<ProjectFormData>({
    onSubmit: submitProject,
    onSuccess: closeOverlay
  })

  return {
    model,
    onSubmit: handleSubmit,
    onCancel: closeOverlay,
    activeTab,
    onTabChange: setActiveTab,
    isLoading: isSubmitting,
    isSubmitting
  }
}
